import type { ConstValues } from '@openx/types/helpers';

export const GoogleProductName = {
  ADMOB: 'ADMOB',
  AD_MANAGER: 'AD_MANAGER',
} as const;
export type GoogleProductName = ConstValues<typeof GoogleProductName>;

export const Result = {
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  ERROR: 'ERROR',
  OTHER: 'OTHER',
} as const;
export type Result = ConstValues<typeof Result>;

export type Listener = (error: Error, data: GoogleData) => void;

export interface GoogleIntegrationState {
  data: GoogleData;
  error: Error;
  pending: boolean;
}

// CTA beta v2
export interface MessageBase {
  version: 'v1' | null | 'v2';
  token: string;
  type: MsgType;
}

export interface InitMessage extends MessageBase {
  type: typeof MsgType.DATA_POINTS_REQUEST;
}

export interface CommonMessage extends MessageBase {
  'origin-product': GoogleProductName;
  'publisher-id': string;
}

export interface AckMessage extends CommonMessage {
  'ack-type': AckMsgType;
}

export interface GoogleData extends CommonMessage {
  // network code is only present for AD_MANAGER origin
  'network-code'?: string;
  'redirect-url': string;
}

export interface ResultData extends CommonMessage {
  'result-value': Result;
  'keep-window-open'?: boolean;
  'result-details'?: string;
}

export const MsgType = {
  DATA_POINTS_REQUEST: 'DATA_POINTS_REQUEST',
  DATA_POINTS: 'DATA_POINTS',
  RESULT: 'RESULT',
  ACK: 'ACK',
  TEST: 'TEST',
  TEST_NEXT: 'TEST_NEXT',
} as const;
export type MsgType = ConstValues<typeof MsgType>;

export type AckMsgType = typeof MsgType.DATA_POINTS | typeof MsgType.RESULT | typeof MsgType.TEST_NEXT;
